import { compose, createStore as createReduxStore } from 'redux'
import { createRootReducer } from './reducers'


let store


export const createStore = ({ reducers, initialState, middleware, throwaway } = ({}, {}, [], false )) => {
  const rootReducer = createRootReducer( reducers )

  if ( middleware ) {
    middleware = compose( ...middleware )
  }

  if ( throwaway ) {
    return createReduxStore( rootReducer, initialState, middleware )
  }

  store = createReduxStore( rootReducer, initialState, middleware )

  return store
}


export const getStore = () => {
  return store
}
